import React from "react";
import img from "../../assets/icons/certificateIcon.png";
import { baseUrl } from "../../utils/base_url";
import {
  _1200px,
  _1400px,
  _1600px,
  _1700px,
  _1800px,
  _576px,
  _768px,
  _992px,
  _450px,
} from "../../utils/mediaBreakpoints";
import { useMediaQuery } from "react-responsive";

const SecurityTestingAndCertification = ({ data }) => {
  const _450 = useMediaQuery({ maxWidth: _450px });
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });

  return (
    <>
      <div className="row" style={{ background: "#090D24" }}>
        <div
          className="d-flex flex-column align-items-center justify-content-center "
          style={{
            padding: _450
              ? "3rem 0rem 2rem 0rem"
              : _768
              ? "5rem 0rem 2.5rem 0rem"
              : _1200
              ? "6rem 0rem 3rem 0rem"
              : _1400
              ? "7rem 0rem 3rem 0rem"
              : "9rem 0rem 4rem 0rem",
            gap: _992 ? "3.5rem" : _1200 ? "4rem" : _1400 ? "5rem" : "7rem",
          }}
        >
          <div className="d-flex flex-column gap-1">
            <p
              style={{
                fontSize: _450
                  ? "25px"
                  : _576
                  ? "25px"
                  : _768
                  ? "25px"
                  : _992
                  ? "30px"
                  : _1200
                  ? "35px"
                  : _1400
                  ? "45px"
                  : _1600
                  ? "55px"
                  : _1700
                  ? "60px"
                  : _1800
                  ? "70px"
                  : "70px",
                // lineHeight:_450? "20px":_576
                //   ? "30px"
                //   : _768
                //   ? "34px"
                //   : _992
                //   ? "38px"
                //   : _1200
                //   ? "48px"
                //   : _1400
                //   ? "54px"
                //   : _1600
                //   ? "60px"
                //   : _1700
                //   ? "66px"
                //   : _1800
                //   ? "70px"
                //   : "70px",
              }}
              className="fw900 text-center text-white lh-sm"
            >
              {data?.heading}
            </p>
            {data?.sub_heading &&
              (() => {
                const phrase = "validated by external experts";
                return (
                  <p
                    className={`text-white text-center lh-sm fw400 px-2 px-md-0`}
                    style={{
                      fontSize: _450
                        ? "20px"
                        : _576
                        ? "20px"
                        : _768
                        ? "17px"
                        : _992
                        ? "17px"
                        : _1200
                        ? "20px"
                        : _1400
                        ? "26px"
                        : _1600
                        ? "32px"
                        : _1700
                        ? "35px"
                        : _1800
                        ? "40px"
                        : "40px",
                      // lineHeight:_450?"18px": _576
                      //   ? "24px"
                      //   : _768
                      //   ? "28px"
                      //   : _992
                      //   ? "30px"
                      //   : _1200
                      //   ? "32px"
                      //   : _1400
                      //   ? "34px"
                      //   : _1600
                      //   ? "36px"
                      //   : _1700
                      //   ? "36px"
                      //   : _1800
                      //   ? "36px"
                      //   : "36px",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: data?.sub_heading?.replace(
                        phrase,
                        `<span style="color: #459EFF">${phrase}</span>`
                      ),
                    }}
                  />
                );
              })()}
          </div>

          <div className="d-flex flex-column flex-sm-row align-items-center justify-content-evenly w-100">
            {data?.certificates?.map((obj, key) => (
              <React.Fragment key={key}>
                <CertificationsCard data={obj} />
              </React.Fragment>
            ))}
          </div>

          <div>
            {data?.description &&
              (() => {
                const phrase = "trust and trace";
                return (
                  <p
                    className={`text-white text-center px-2 px-md-0 fw900 lh-sm`}
                    style={{
                      fontSize: _450
                        ? "20px"
                        : _576
                        ? "20px"
                        : _768
                        ? "18px"
                        : _992
                        ? "18px"
                        : _1200
                        ? "24px"
                        : _1400
                        ? "26px"
                        : _1600
                        ? "32px"
                        : _1700
                        ? "35px"
                        : _1800
                        ? "40px"
                        : "40px",
                      // lineHeight:_450 ?"14px":_576
                      //   ? "18px"
                      //   : _768
                      //   ? "20px"
                      //   : _992
                      //   ? "24px"
                      //   : _1200
                      //   ? "30px"
                      //   : _1400
                      //   ? "35px"
                      //   : _1600
                      //   ? "40px"
                      //   : _1700
                      //   ? "46px"
                      //   : _1800
                      //   ? "50px"
                      //   : "50px",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: data?.description
                        ?.replace(
                          phrase,
                          `<span style="color: #459EFF">${phrase}</span>`
                        )
                        ?.split("\n")
                        ?.join("<br/>"),
                    }}
                  />
                );
              })()}
          </div>
        </div>
      </div>
    </>
  );
};

export const CertificationsCard = ({ data }) => {
  const _450 = useMediaQuery({ maxWidth: _450px });
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });
  return (
    <>
      <div
        className="d-flex flex-column align-items-center justify-content-center pb-5 pb-sm-0"
        style={{
          gap: _576 ? "1rem" : _768 ? "2rem" : _1400 ? "3rem" : "4rem",
        }}
      >
        <div>
          <img
            src={`${baseUrl}${data?.image?.url}`}
            alt=""
            width={
              _450
                ? 70
                : _576
                ? 70
                : _768
                ? 60
                : _992
                ? 70
                : _1200
                ? 70
                : _1400
                ? 80
                : _1600
                ? 90
                : _1700
                ? 100
                : _1800
                ? 120
                : 120
            }
          />
        </div>
        <div className="text-center d-flex gap-1 flex-column">
          <span
            className="fw800 lh-1"
            style={{
              fontSize: _450
                ? "15px"
                : _576
                ? "15px"
                : _768
                ? "14px"
                : _992
                ? "15px"
                : _1200
                ? "15px"
                : _1400
                ? "17px"
                : _1600
                ? "19px"
                : _1700
                ? "22px"
                : _1800
                ? "26px"
                : "26px",
              // lineHeight: _450
              //   ? "10px"
              //   : _576
              //   ? "11px"
              //   : _768
              //   ? "11px"
              //   : _992
              //   ? "15px"
              //   : _1200
              //   ? "15px"
              //   : _1400
              //   ? "17px"
              //   : _1600
              //   ? "19px"
              //   : _1700
              //   ? "22px"
              //   : _1800
              //   ? "26px"
              //   : "26px",
              color: "#459EFF",
            }}
            dangerouslySetInnerHTML={{
              __html: data?.title_1?.split("\n")?.join("<br/>"),
            }}
          />

          <span
            className="fw700 text-white lh-1"
            style={{
              fontSize: _450
                ? "11px"
                : _576
                ? "11px"
                : _768
                ? "9px"
                : _992
                ? "9px"
                : _1200
                ? "10px"
                : _1400
                ? "10px"
                : _1600
                ? "11px"
                : _1700
                ? "13px"
                : _1800
                ? "16px"
                : "16px",
              // lineHeight: _450
              //   ? "6px"
              //   : _576
              //   ? "8px"
              //   : _768
              //   ? "8px"
              //   : _992
              //   ? "9px"
              //   : _1200
              //   ? "10px"
              //   : _1400
              //   ? "11px"
              //   : _1600
              //   ? "13px"
              //   : _1700
              //   ? "15px"
              //   : _1800
              //   ? "20px"
              //   : "20px",
            }}
            dangerouslySetInnerHTML={{
              __html: data?.title_2?.split("\n")?.join("<br/>"),
            }}
          />
        </div>
      </div>
    </>
  );
};

export default SecurityTestingAndCertification;
